<app-viewer-survey *ngIf="activeSurvey" [data]="activeSurvey" (answered$)="answered()" (close)="close()"></app-viewer-survey>
